module.exports = __webpack_public_path__ + "img/656aa8b.png";